/* eslint-disable react-perf/jsx-no-new-function-as-prop */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Flex } from '@rebass/grid';

import { Button } from 'app/shared/ui';
import { MobileForm } from 'app/marketplace/SlideInBanners/shared/Components/MobileForm/MobileForm';
import { NEWSLETTER_SOURCE } from 'app/marketplace/crm/constants';
import { noop } from 'app/shared/utils/utils';
import { useSlideIn } from 'app/marketplace/SlideInBanners/shared/hooks/mobile/useSlideIn';
import {
  formTranslations,
  successTranslations,
} from 'app/marketplace/SlideInBanners/CrmBanner/MobileBanner/translationMessages';
import { tracking } from 'app/marketplace/SlideInBanners/CrmBanner/MobileBanner/MobileBanner.tracking';

import {
  IconCloseSt,
  ImageSt,
  ModalSt,
  SignupButtonTextSt,
  BannerTextSt,
} from './MobileBanner.css';

export const MobileBanner = ({
  closeOverlay,
  openOverlay,
  onFormSubmit,
  done,
  finishSubmit,
  onClose,
  areCookiesAccepted,
  threshold,
  submitted,
  target,
}) => {
  const [mode, changedToVisible, setMode] = useSlideIn(threshold, target);

  useEffect(() => {
    if (changedToVisible) {
      tracking.changedToVisible();
    }
  }, [changedToVisible]);

  const handleClick = (e) => {
    e.preventDefault();
    tracking.openModal();
    openOverlay(MobileForm, {
      props: {
        onFormSubmit,
        done,
        finishSubmit,
        openOverlay,
        closeOverlay,
        tracking,
        source: NEWSLETTER_SOURCE.mobileSlideIn,
        formTranslations,
        successTranslations,
      },
    });
  };

  const closeModal = () => {
    tracking.dismissed();
    setMode('slideOut');
    setTimeout(() => {
      onClose(areCookiesAccepted);
    }, 500);
  };

  // Hide modal when user submits form.
  if (submitted) return null;

  return (
    <ModalSt mode={mode}>
      <ImageSt>
        <img
          src="/assets/crm/CRM_Banner.png"
          srcSet="/assets/crm/CRM_Banner@2x.png 2x"
          alt="mobile crm banner"
        />
      </ImageSt>
      <Flex flex={3} flexDirection="column" justifyContent="center" px={12}>
        <BannerTextSt>Neue Angebote & Tipps zur Autosuche</BannerTextSt>
        <Button onClick={handleClick} unstyled>
          <SignupButtonTextSt>Jetzt anmelden</SignupButtonTextSt>
        </Button>
      </Flex>
      <IconCloseSt onClick={closeModal} className="if-icon-close" />
    </ModalSt>
  );
};

MobileBanner.propTypes = {
  openOverlay: PropTypes.func,
  closeOverlay: PropTypes.func,
  onFormSubmit: PropTypes.func,
  done: PropTypes.bool,
  finishSubmit: PropTypes.func,
  target: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  areCookiesAccepted: PropTypes.bool,
  threshold: PropTypes.number.isRequired,
  submitted: PropTypes.bool,
};

MobileBanner.defaultProps = {
  openOverlay: noop,
  closeOverlay: noop,
  onFormSubmit: noop,
  done: false,
  finishSubmit: noop,
  onClose: noop,
  areCookiesAccepted: false,
  submitted: false,
};
